import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from "react-router-dom";
import { GetInstituteInformation } from '../../../Actions/StudentA';
import { BaseUrl } from '../../../Actions/Base';
import ImageAndPrice from '../../CourseCategory/Components/CourseTiles/ImageAndPrice';
import { CourseInfo } from '../../CourseCategory/Components/CourseTiles/Navigation';
import { RatingBtns } from '../../CourseCategory/Components/CourseTiles/Navigation';
import { Link } from "react-router-dom";
import CourseBanner from "../Assets/coursesbanner.svg"
import { AddtoWishList, RemoveFromWishList, GetWishList } from '../../../Actions/UserA';
import { OpenLoginSignUp } from '../../../Actions/ToggleSignupA';
import RedIcon from "../Assets/RedIcon.png";

const CourseOfferings = ({InstituteAllCoursesInformation}) => {
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const Dispatch = useDispatch()

    const [wishlistMap, setWishlistMap] = useState({});

    const { WishList } = useSelector((Store) => Store.WishListReducer)
    const { Authenticated, loading } = useSelector((Store) => Store.LoginSignupReducer)
    console.log("WishList in CourseOfferings is:",WishList)

    const AddToWishlist = (e, InstituteCourseId) => {
        e.stopPropagation();
        if (!Authenticated) {
            alert("Please login to add to wishlist.");
            return;
        }
        Dispatch(AddtoWishList(InstituteCourseId));
    };
    
    // const RemoveFromWishlist = (e, InstituteCourseId) => {
    //     e.stopPropagation();
    //     if (!Authenticated) {
    //         alert("Please login to remove from wishlist.");
    //         return;
    //     }
    //     Dispatch(RemoveFromWishList(InstituteCourseId));
    // };

    // const AddToWishlist = async (e, InstituteCourseId) => {
    //     e.stopPropagation();
    //     e.preventDefault();
        
    //     if (!Authenticated) {
    //         alert("Please login to add to wishlist.");
    //         return;
    //     }
    
    //     // Remove existing one first
    //     const existingCourse = Object.entries(wishlistMap).find(([key, value]) => value.isInWishlist);
    //     if (existingCourse) {
    //         const existingWishId = existingCourse[1]?.wishId;
    //         if (existingWishId) {
    //             await Dispatch(RemoveFromWishList(existingWishId));
    //         }
    //     }
    
    //     // Add new one
    //     await Dispatch(AddtoWishList(InstituteCourseId));
    
    //     // Update local map optimistically
    //     setWishlistMap({
    //         [InstituteCourseId]: { isInWishlist: true, wishId: null }  // wishId will update when redux syncs
    //     });
    // };

    const RemoveFromWishlist = async (e, InstituteCourseId) => {
        e.stopPropagation();
        e.preventDefault();
    
        if (!Authenticated) {
            alert("Please login to remove from wishlist.");
            return;
        }
    
        const wishId = wishlistMap[InstituteCourseId]?.wishId;
        if (wishId) {
            await Dispatch(RemoveFromWishList(wishId));
    
            // Remove only the specific course from the local wishlistMap
            setWishlistMap((prevMap) => {
                const updatedMap = { ...prevMap };
                delete updatedMap[InstituteCourseId];
                return updatedMap;
            });
        }
    };
    
    
    // const RemoveFromWishlist = async (e, InstituteCourseId) => {
    //     e.stopPropagation();
    //     e.preventDefault();
    
    //     if (!Authenticated) {
    //         alert("Please login to remove from wishlist.");
    //         return;
    //     }
    
    //     const wishId = wishlistMap[InstituteCourseId]?.wishId;
    //     if (wishId) {
    //         await Dispatch(RemoveFromWishList(wishId));
    
    //         // Update local map
    //         setWishlistMap({});
    //     }
    // };
    

    useEffect(() => {
        if (Authenticated && !WishList) 
            Dispatch(GetWishList())
        
    }, [Authenticated, WishList, Dispatch])
    

    // useEffect(() => {
    //     if (WishList?.length && InstituteAllCoursesInformation?.courses?.length) {
    //         const map = {};
    //         InstituteAllCoursesInformation.courses.forEach(course => {
    //             const match = WishList.find(item => item.ProductFK === course.InstituteCourseId);
    //             map[course.InstituteCourseId] = {
    //                 isInWishlist: !!match,
    //                 wishId: match?.WishId || null
    //             };
    //         });
    //         setWishlistMap(map);
    //     }
    // }, [WishList, InstituteAllCoursesInformation]);

    useEffect(() => {
        if (WishList?.length && InstituteAllCoursesInformation?.courses?.length) {
            const map = {};
            InstituteAllCoursesInformation.courses.forEach(course => {
                const match = WishList.find(item => item.ProductFK === course.InstituteCourseId);
                if (match) {
                    map[course.InstituteCourseId] = {
                        isInWishlist: true,
                        wishId: match.WishId
                    };
                }
            });
            setWishlistMap(map);
        } else {
            setWishlistMap({});
        }
    }, [WishList, InstituteAllCoursesInformation]);
    
    
      
    return (
        <div className='w-full flex justify-center items-center mt-[40px]'>
            <div className='w-[90%] flex flex-col gap-[20px]'>
                <p className='text-[30px] font-bold text-center lg:text-left'>Courses Offered</p>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-[40px] gap-y-[20px] mt-[20px]'>
                     {InstituteAllCoursesInformation.courses.map((course, index) => (
                        <div key={index} className={`w-[350px] p-[30px] rounded-[12px] bg-[#FFFFFF] shadow-[4px_5px_6px_#00000029] ${Border}`}>
                            <Link
                                to={`/course/${course?.InstituteCourseId}`}
                                className={`no-underline duration-300 hover:bg-[#BCBEFF] cursor-pointer`}
                            >
                                <div className="flex flex-col gap-[20px]">
                                    <div className="relative h-[200px]">
                                        <img className="w-full h-[200px] object-cover" 
                                            src={`${BaseUrl}/api/LicenseType/Image?url=${course.CourseThumbnail}`} alt="Courseimg" />

                                        <div className='absolute bottom-[-10px] left-1/2 transform -translate-x-1/2 bg-white rounded-[12px] flex justify-center items-center w-[120px] h-[50px] p-[10px] shadow-[4px_5px_6px_#00000029]'>
                                            <p className="text-[16px] text-[#000000]">
                                                {course?.TotalFee 
                                                    ? `$ ${parseFloat(course.TotalFee).toFixed(2)}`
                                                    : "Fee not available"}
                                                <sup> +Tax</sup>
                                            </p>

                                        </div>

                                        <span className={`w-8 h-8 flex justify-center items-center bg-white absolute  rounded-[16px] cursor-pointer
                                            top-2     md:top-5 
                                            right-8   md:right-5`}
                                        >
                                            
                                            {
                                                !wishlistMap[course?.InstituteCourseId] ? (
                                                    <img 
                                                        className='h-6 relative -top-[2px] md:top-0 md:h-auto' 
                                                        src={require('../Assets/Favourite Icon.svg').default} 
                                                        alt=""
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            AddToWishlist(e, course?.InstituteCourseId);
                                                        }}
                                                    />
                                                ) : (
                                                    <img 
                                                        className='h-6 relative -top-[2px] md:top-0 md:h-auto' 
                                                        // src={require('../Assets/RedIcon.png').default}
                                                        src={RedIcon} 
                                                        alt=""
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            // const wishId = wishlistMap[course?.InstituteCourseId]?.wishId;
                                                            // if (wishId) RemoveFromWishlist(e, wishId);
                                                            RemoveFromWishlist(e, course?.InstituteCourseId);
                                                        }}
                                                    />
                                                )
                                            }
                                        </span>
                                    </div>

                                    <p className='text-[20px] font-bold text-[#000000] text-center'>{course.CourseName}</p>
                                    <p className='text-[18px] text-[#3B3735] text-center px-[10px]'>{course.CourseDescription}</p>

                                    <div className='flex flex-col gap-[10px]'>
                                        {course?.AverageRating && (
                                        <div className='flex gap-[10px]'>
                                            {[...Array(course?.AverageRating)].map((_, index) => (
                                                <img
                                                    key={index}
                                                    className='w-[14px] sm:w-auto'
                                                    src={require('../Assets/StarIcon.svg').default}
                                                    alt='Star'
                                                />
                                                ))} 
                                        </div>
                                        )}

                                        <div className='flex justify-between items-center'>
                                            {course?.AverageRating ? (
                                            <div className='flex gap-[10px]'>
                                                <img className='h-5 cursor-pointer ' src={require('../Assets/ThumbIcon.svg').default} alt="Thumb Icon" />
                                                <p className='text-[18px] text-bold text-[#000000]'>{course?.AverageRating * 20}% ({course?.TotalReviews})</p>
                                            </div>
                                            ) : (
                                                <div className='flex gap-[10px]'>
                                                </div>
                                            )}

                                            <div className='flex gap-[10px]'>
                                                <p className='text-[16px] text-[#163235]'>{InstituteAllCoursesInformation.institute?.State} | {InstituteAllCoursesInformation.institute?.City}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))} 
                </div>
            </div>
        </div>
    )
}

export default CourseOfferings